/**
 * Codici delle tipologie di intervento che cambiano il flusso di valutazione.
 *
 * Rispecchiano le costanti di App\Models\InterventionClass lato backend: se si
 * aggiunge un codice là, va aggiunto anche qui.
 */
export const INTERVENTION = {
  /** Finanziamento a breve termine (ex proponente Controparte, CTP). */
  SHORT_TERM_FINANCING: 'SHORTFIN',
  /** Produzione Audiovisiva, finanziamento per altra finalità. */
  AUDIOVISUAL_OTHER: 'AUDOTHER',
  /** Produzione Audiovisiva, finanziamento per produzione specifica. */
  AUDIOVISUAL_PRODUCTION: 'AUDPROD',
  /** Acquisto di struttura preesistente. */
  NO_INTERVENTION_PURCHASE: 'NOINTPURCH',
};

/**
 * Tipologie che seguono il flusso Controparte: non finanziano un progetto
 * d'investimento, quindi solo valutazione ESG, parametri SROI a zero e niente
 * sezione SROI da compilare.
 */
export const COUNTERPARTY_FLOW = [
  INTERVENTION.SHORT_TERM_FINANCING,
  INTERVENTION.AUDIOVISUAL_OTHER,
];

/** Il progetto segue il flusso Controparte? */
export const isCounterpartyFlow = (interventionClassCode) =>
  COUNTERPARTY_FLOW.includes(interventionClassCode);

/**
 * Il progetto segue il flusso audiovisivo con le opere (quello storico)?
 *
 * Si decide per esclusione invece che su AUDPROD perché i progetti audiovisivi
 * creati prima del 04/10/2026 hanno `intervention_class_code = 'NEW'`: il
 * frontend lo forzava e il selettore non esisteva. Con il controllo per
 * esclusione continuano a funzionare senza doverli migrare, e senza spostare 82
 * progetti inviati da "Nuova costruzione" a una categoria nuova nei grafici per
 * tipologia di intervento.
 */
export const isAudiovisualProductionFlow = (proponentCode, interventionClassCode) =>
  proponentCode === 'AUD' && !isCounterpartyFlow(interventionClassCode);
